/// <reference path="../../ts/libs.ts" />

import { ButtonType, OutlineTextFieldWidget, TextInputType } from '@tableau/widgets';
import * as React from 'react';
import { defaultMemoize } from 'reselect';
import { Messages } from '../../codegen/Localize';
import { ButtonWithSpinner } from '../../common/react/components/ButtonWithSpinner';
import { SiteRolePickerMenu } from '../../common/react/components/SiteRolePickerMenu';
import { AngularContext } from '../../ts/factories/AngularContextFactory';
import { SiteRolePickerMenuHelper } from '../../ts/helpers/SiteRolePickerMenuHelper';
import { SiteRoleOption, SiteRoleOptionsResource } from '../../ts/resources/SiteRoleOptions';
import { SiteRoles } from '../../ts/ServerApi/types/ISiteRole';
import { AddLocalUserDialogType } from '../../ts/services/AddLocalUserAction';
import { ServerService } from '../../ts/services/ServerService';
import { AuthenticationProviderType } from '../../ts/services/SiteAuthenticationSettingsService';
import { ServiceLocator } from '../ServiceLocator';
import { IFormModel } from './AddLocalUsersDialog';
import { SiteRolePopover } from './SiteRolePopover';
import { ISiteRoleChanges, SiteRolesPickerContainer } from './SiteRolesPickerContainer';

export interface CreateLocalUserOnOtherSiteFormState {
}

export interface CreateLocalUserOnOtherSiteFormProps {
  readonly angularContext: AngularContext;
  readonly availableQuota: number;
  readonly busy: boolean;
  readonly formModel: IFormModel;
  readonly addLocalUserDialogType: string;
  readonly siteRole: string;
  readonly sitePickerMenuDisabled: boolean;
  readonly onProceedClickedHandler: () => void;
  readonly getSiteRoleOptionBySiteRoleHandler: (siteRole: string) => SiteRoleOption;
  readonly onOptionSelectedHandler: (siteRoleOption: SiteRoleOption) => void;
}

const getDisabledRoleOptionsHandler = defaultMemoize((availableQuota: number, siteRoleOptions: SiteRoleOption[]): ReadonlyArray<SiteRoleOption> => SiteRolePickerMenuHelper.getPickerMenuDropdownOptionDisabledOptions(availableQuota, siteRoleOptions));

export class CreateLocalUserOnOtherSiteForm extends React.Component<CreateLocalUserOnOtherSiteFormProps, CreateLocalUserOnOtherSiteFormState> {

  private server: ServerService = ServiceLocator.get<ServerService>('ServerService');
  private siteRolesOptionResource: SiteRoleOptionsResource = ServiceLocator.get<SiteRoleOptionsResource>('SiteRoleOptionsResource');
  private translate: ng.translate.ITranslateService = ServiceLocator.get<ng.translate.ITranslateService>('$translate');
  private roleOptions = this.server.isSessionServerAdmin() === false ? this.siteRolesOptionResource.getAllSiteRoleOptionsExcept(SiteRoles.ServerAdministrator) : this.siteRolesOptionResource.getAllSiteRoleOptions();

  public render() {
    return(<tbody className="tb-otherSiteFlow-table">
            <tr>
              <td className="tb-text-input-label-cell">
                <label>{Messages.displayName_colon()}</label>
              </td>
              <td className="tb-immutable-text-cell">
                <label>{this.props.formModel.otherSiteFlowModel.displayName}</label>
              </td>
            </tr>
            <tr>
              <td/>
              <td className="tb-warningCell">
                <div className="tb-proceed-button">
                  <ButtonWithSpinner buttonType={ButtonType.Outline}
                                     testId={'proceed'}
                                     title={Messages.proceed()}
                                     clicked={this.props.onProceedClickedHandler}
                                     disabled={this.props.formModel.otherSiteFlowModel.proceedClicked}/>
                </div>
                <span className="tb-warning-text">{this.props.formModel.otherSiteFlowModel.warningText}</span>
              </td>
            </tr>
            {this.showSitePickerMenu()}
          </tbody>);
  }

  private showSitePickerMenu(): JSX.Element {
    if (this.props.addLocalUserDialogType === AddLocalUserDialogType.site) {
      return(<tr>
              <td className="tb-react-text-input-label-cell">{Messages.siteRole_colon()}</td>
              <td className="tb-settings-control tb-react-input-wide">
                <SiteRolePickerMenu
                  translate={this.translate.instant}
                  siteRoleOptions={this.roleOptions}
                  getSiteRoleOptionBySiteRole={this.props.getSiteRoleOptionBySiteRoleHandler}
                  onOptionSelected={this.props.onOptionSelectedHandler}
                  selectedRole={this.siteRolesOptionResource.getSiteRoleOptionBySiteRole(this.props.siteRole)}
                  isDisabled={this.props.busy || this.props.sitePickerMenuDisabled}
                  disabledRoleOptions={[...getDisabledRoleOptionsHandler(this.props.availableQuota, this.roleOptions)]}/>
              </td>
              <td className="tb-settings-control tb-react-site-role-popover">
                <SiteRolePopover angularContext={this.props.angularContext} showIconWithoutTitle={true} className={'localPopover'}/>
              </td>
            </tr>);
    }
    return (null);
  }

}
